import React, { useState, useEffect, useContext, useRef,useCallback} from "react";
import DatePicker from "react-datepicker";

//import ChartColumn from './../../components/chart/column';
import ProgressChart from "../chart/progresschart.js";
import ReportCreate from "../chart/reportCreator";
import Piechart from "../chart/piechart.js";
import Donutchart from "../chart/donutchart";
import moment from "moment";
import RenderButton from "../common/button";
import BranchContext from "../context/branch";
// import Header from "./header";
import ScrollToTop from "../common/ScrollToTop";
// import Renderdetails from "./rendercockdetail";
import { toast } from 'react-toastify';
import {getdashboard,getdashboardOS,getdashboardAge,getdashboardSoftware,getdashboardPC,getdashboardcheckdate} from '../../services/pc';


  const Reportregister = (props) => {

  const { currentBranch } = useContext(BranchContext);
  const [startDate, setStartDate] = useState(new Date());
  const [value, setValue] = useState(14);
  const [total,setTotal] = useState(0);
  const [id, setid] = useState(0);
  const [hour, sethour] = useState(0);
  const [amountcompare, setAmountcompare] = useState([]);
  const [devicelist, setdevicelist] = useState([]);
  const [scanlist, setscanlist] = useState([]);
  const [dataall, setDataall] = useState({});
  const [data1, setData1] = useState({});
  const [data2, setData2] = useState({});
  const [data3, setData3] = useState({});
  const [data4, setData4] = useState({});
  const [data5, setData5] = useState({});
  const [data6, setData6] = useState({});
  const [chartdatapermit, setchartdatapermit] = useState([]);
  const [chartdatahour, setchartchartdatahour] = useState([]);
  const [graphtype, setgraphtype] = useState("bar");
  const [devicename, setdevicename] = useState("");
  const [ip1, setip1] = useState(0);
  const [dap, setdap] = useState(0);
  const [ip2, setip2] = useState(0);
  const [bitec, setbitec] = useState(0);
  const [showonscroll, setshowonscroll] = useState(false)
  const [onprocess, setonprocess] = useState(false)
  const [pageSize, setPageSize] = useState(2000);
  const [statusId,setstatusid] = useState(0);
  const [hasMore, setHasMore] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [detials, setdetials] = useState([]);
  const [datalist, setdatalist] = useState([]);
 const [oslist, setoslist] = useState([]);
 const [agelist, setagelist] = useState([]);
 const [softwarelist, setsoftwarelist] = useState([]);
 const [pclist, setpclist] = useState([]);
 const [worklist, setworklist] = useState([]);

 


  //  useEffect(() => {
  //   if (!currentBranch) return;

  //   const loadData = async () => {

  //     const { data: result } = await getUserCurrent()
  
  //       if (result.status === "success") {
  //         setTotal(result.data.total);
  //         setip1(result.data.IP1);
  //         setip2(result.data.IP2)
  //         setdap(result.data.DAP)
  //         setbitec(result.data.BITEC)
        
         
  //       }else if (result.status ==="error") {
         
  //       }
  //   };
  //   loadData();
  // }, [currentBranch, ]);



  useEffect(() => {
    if (!currentBranch) return;

    const loadData = async () => {

      const { data: result } = await getdashboard()
  
        if (result) {
      
          setdatalist(result);
             
        }
    };
    loadData();
  }, [currentBranch ]);

  useEffect(() => {
    if (!currentBranch) return;

    const loadData = async () => {

      const { data: result } = await getdashboardPC()
  
        if (result) {
      
          setpclist(result);
             
        }
    };
    loadData();
  }, [currentBranch ]);

  useEffect(() => {
    if (!currentBranch) return;

    const loadData = async () => {

      const { data: result } = await getdashboardcheckdate()
  
        if (result) {
      
          setworklist(result);
             
        }
    };
    loadData();
  }, [currentBranch ]);

  useEffect(() => {
    if (!currentBranch) return;

    const loadData = async () => {

      const { data: result } = await getdashboardSoftware()
  
        if (result) {
      
          setsoftwarelist(result);
             
        }
    };
    loadData();
  }, [currentBranch ]);


  useEffect(() => {
    if (!currentBranch) return;

    const loadData = async () => {

      const { data: result } = await getdashboardAge()
  
        if (result) {
      
         setagelist(result);
             
        }
    };
    loadData();
  }, [currentBranch, ]);

  useEffect(() => {
    if (!currentBranch) return;

    const loadData = async () => {

      const { data: result } = await getdashboardOS()
  
        if (result) {
      
         setoslist(result);
             
        }
    };
    loadData();
  }, [currentBranch, ]);

  // useEffect(() => {
  //   if (!currentBranch) return;

  //   const loadData = async () => {

  //     const { data: result } = await getUserCurrentbyArea(7)
  
  //       if (result) {
      
  //        setareabitec(result);
             
  //       }
  //   };
  //   loadData();
  // }, [currentBranch, ]);

  useEffect(() => {
    if (!datalist || !currentBranch) return;
    const chart = () => {
      let label = [];
      let total = [];
      let target = [];
      let totaltoday = [];
      let totalall = 0
      for (const dataObj of datalist) {
        label.push(dataObj.name  );
        total.push(parseInt(dataObj.total));   
        totaltoday.push(parseInt(dataObj.totaltoday)); 
        target.push(parseInt(dataObj.target));   
        totalall = totalall + parseInt(dataObj.total)    
      }
      const data =
      {
        series: [
          { name: "target", data: target } ,
          { name: "ทั้งหมด", data: total } ,
          { name: "วันนี้", data: totaltoday }         
        ],
        dataLabels: {
          formatter: function (val, opts) {
              return opts.w.config.series[opts.seriesIndex]
          },
        },       
        yLabels: label,
        headers:
          "ข้อมูลตรวจเช็คเทียบพื้นที่ ทั้งหมด (" + totalall +")",
         
        type: "bar",
        stacked: false,
      };
  setData1(data);   
    };
    chart();
  }, [datalist, currentBranch]);

  useEffect(() => {
    if (!pclist || !currentBranch) return;
    const chart = () => {
      let label = [];
      let total = [];
      let pc = [];
      let nb = [];
      
      for (const dataObj of pclist) {
        label.push(dataObj.name  );
        // total.push(parseInt(dataObj.total));   
        pc.push(parseInt(dataObj.pc)); 
        nb.push(parseInt(dataObj.nb));   
          
      }
      const data =
      {
        series: [
       
          // { name: "ทั้งหมด", data: total } ,
          { name: "PC", data: pc }    ,
          { name: "Labtop", data: nb } ,     
        ],
        dataLabels: {
          formatter: function (val, opts) {
              return opts.w.config.series[opts.seriesIndex]
          },
        },       
        yLabels: label,
        headers:
          "ข้อมูลตรวจเช็ค PC เทียบ Labtop ",
         
        type: "bar",
        stacked: true,
      };
  setData5(data);   
    };
    chart();
  }, [pclist, currentBranch]);
  
  useEffect(() => {
    if (!worklist || !currentBranch) return;
    const chart = () => {
      let label = [];
      let total = [];
     
      
      for (const dataObj of worklist) {
        label.push(dataObj.name  );
        total.push(parseInt(dataObj.total));   
      
          
      }
      const data =
      {
        series: [
       
          { name: "จำนวน", data: total } ,
           
        ],
        dataLabels: {
          formatter: function (val, opts) {
              return opts.w.config.series[opts.seriesIndex]
          },
        },       
        yLabels: label,
        headers:
          "ข้อมูลตรวจเช็คต่อวัน ",
         
        type: "bar",
        stacked: false,
      };
  setData6(data);   
    };
    chart();
  }, [worklist, currentBranch]);

  useEffect(() => {
    if (!oslist || !currentBranch) return;
    const chart = () => {
      let label = [];
      let total = [];
      for (const dataObj of oslist) {
        label.push(dataObj.name + ' (' + dataObj.total +')');
        total.push(parseInt(dataObj.total));       
      }
      const data =
      {
        series: [
          { name: "OS", data: total }          
        ],
        dataLabels: {
          formatter: function (val, opts) {
              return opts.w.config.series[opts.seriesIndex]
          },
        },       
        yLabels: label,
        headers:
          "ข้อมูลเข้าออกรายชั่วโมง (คน) วันที่ " ,
         
        type: "bar",
        stacked: false,
      };
  setData2(data);   
    };
    chart();
  }, [oslist, currentBranch]);

  useEffect(() => {
    if (!softwarelist || !currentBranch) return;
    const chart = () => {
      let label = [];
      let total = [];
      for (const dataObj of softwarelist) {
        label.push(dataObj.name + ' (' + dataObj.total +')');
        total.push(parseInt(dataObj.total));       
      }
      const data =
      {
        series: [
          { name: "Software", data: total }          
        ],
        dataLabels: {
          formatter: function (val, opts) {
              return opts.w.config.series[opts.seriesIndex]
          },
        },       
        yLabels: label,
        headers:
          "รายชื่อ Software ที่ตรวจพบ " ,       
        type: "bar",
        stacked: false,
      };
  setData4(data);   
    };
    chart();
  }, [softwarelist, currentBranch]);

  useEffect(() => {
    if (!agelist || !currentBranch) return;
    const chart = () => {
      let label = [];
      let total = [];
      for (const dataObj of agelist) {
        label.push(dataObj.name + ' (' + dataObj.total +')');
        total.push(parseInt(dataObj.total));       
      }
      const data =
      {
        series: [
          { name: "Age", data: total }          
        ],
        dataLabels: {
          formatter: function (val, opts) {
              return opts.w.config.series[opts.seriesIndex]
          },
        },       
        yLabels: label,
        headers:
          "ข้อมูลเข้าออกรายชั่วโมง (คน) วันที่ " ,
         
        type: "bar",
        stacked: false,
      };
  setData3(data);   
    };
    chart();
  }, [agelist, currentBranch]);



  // useEffect(() => {
  //   if (!areabitec || !currentBranch) return;
  //   const chart = () => {
  //     let label = [];
  //     let total = [];
  //     for (const dataObj of areabitec) {
  //       label.push(dataObj.lebel + ' (' + dataObj.total +')');
  //       total.push(parseInt(dataObj.total));       
  //     }
  //     const data =
  //     {
  //       series: [
  //         { name: "เข้า", data: total }          
  //       ],
  //       dataLabels: {
  //         formatter: function (val, opts) {
  //             return opts.w.config.series[opts.seriesIndex]
  //         },
  //       },       
  //       yLabels: label,
  //       headers:
  //         "ข้อมูลเข้าออกรายชั่วโมง (คน) วันที่ " ,
         
  //       type: "bar",
  //       stacked: false,
  //     };
  // setData4(data);   
  //   };
  //   chart();
  // }, [areabitec, currentBranch]);
  const chartopions = {
    theme: {
      mode: "light",
      palette: "palette6",
      monochrome: {
        enabled: false,
        color: "#255aee",
        shadeTo: "light",
        shadeIntensity: 0.65,
      },
    },
    dataLabels: {
      formatter: function (val, opts) {
          return opts.w.config.series[opts.seriesIndex]
      },
    },

  };


  // useEffect(() => {
  // //  console.log(ip2)
  //   //!ip1 || ip2 !== undefined || !dap || !bitec ||
  //   if ( !currentBranch) return;
  //   const chart = () => {
  //     let label = [];
  //     let total = [];
  //     // for (const dataObj of areaip1) {
  //     //   label.push(dataObj.lebel + ' (' + dataObj.total +')');
  //     label.push("IP1 "+ ip1);
  //      total.push(parseInt(ip1));  
  //      label.push("IP2 " + ip2);
  //      total.push(parseInt(ip2));  
  //      label.push("DAP " + dap); 
  //      total.push(parseInt(dap));    
  //      label.push("BITEC "+ bitec);
  //      total.push(parseInt(bitec));   

  //     // }
    
  //     const data =
  //     {
  //       series: [
  //         { name: "เข้า", data: total }          
  //       ],
  //       dataLabels: {
  //         formatter: function (val, opts) {
  //             return opts.w.config.series[opts.seriesIndex]
  //         },
  //       },       
  //       yLabels: label,
  //       headers:
  //         "พนักงานเข้าทำงานแยกตาม Site (คน)" ,
         
  //       type: "bar",
  //       stacked: false,
  //     };
  //     setDataall(data);   
  //   };
  //   chart();
  // }, [ip1,ip2,dap,bitec, currentBranch]);


  const handleonClick = (hour,Id) => {
    setPageSize(1);
    setid(Id);
    sethour(hour);
    
//console.log(date,action);
  }




 // console.log(data1 && data1.series[0].data);
  
  if (!currentBranch 
    // || data1.series == undefined 
    // || data2.series == undefined 
    // || data3.series == undefined 
    // || data3.series == undefined 
    // || dataall.series == undefined
  ) {
    return <></>;
  }

  // if (chartdatacomparetotal.series[0].length == 0){

  //   return <></>;
  // }

  //console.log(chartdatacomparecompany)
  return (
    <div className=" container-fluid">
      <div className="m-1 d-flex justify-content-center mb-2">
      <span className="badge rounded-pill bg-warning" style={{ fontSize: "16px" }}>
       ข้อมูลสรุปการตรวจเช็ค PC
      </span>
      </div>
  

      <div >
        {/* <div className="container ">
          <div className="row  m-3">
            
            <div className="col-md-2 m-1 d-flex justify-content-center">
                
                <button
                  className="btn btn-primary   d-flex justify-content-center"
                  style={{ height: 80, width: 170}}
                  type="button"
                >
                  <div className="container m-2">
                    <h5> All </h5>
                    <h5>{total}</h5>
                  </div>
                </button>
                </div>

                <div className="col-md-2 m-1 d-flex justify-content-center">
                
                <button
                  className="btn btn-warning   d-flex justify-content-center"
                  style={{ height: 80, width: 170}}
                  type="button"
                >
                  <div className="container m-2">
                    <h5> IP1 </h5>
                    <h5>{ip1}</h5>
                  </div>
                </button>
                </div>


            <div className="col-md-2 m-1 d-flex justify-content-center">
                
                <button
                  className="btn btn-secondary    d-flex justify-content-center"
                  style={{ height: 80, width: 170}}
                  type="button"
                >
                  <div className="container m-2">
                    <h5>IP2</h5>
                    <h5>{ip2}</h5>
                  </div>
                </button>
                </div>
               
                <div className="col-md-2 m-1 d-flex justify-content-center">
              
                <button
                  className="btn btn-info   d-flex justify-content-center"
                  style={{ height: 80, width: 170}}
                  type="button"
                >
                  <div className="container m-2">
                    <h5>DAP</h5>
                    <h5>{dap}</h5>
                  </div>
                </button>
                </div>
              
                <div className="col-md-2  m-1 d-flex justify-content-center">
               
               <button
                 className="btn btn-success   d-flex justify-content-center"
                 style={{ height: 80, width: 170}}
                 type="button"
               >
                 <div className="container m-2">
                   <h5>OTHER</h5>
                   <h5>{bitec}</h5>
                 </div>
               </button>
               </div>

          </div>
        </div> */}


        <div className="row">


        <div className="col-lg-6">
            <div className="mt-1">

            {data1.series !== undefined && <ReportCreate
            data={data1}
            type={graphtype}           
            labelposition="top"
             palette={"palette1"}
            onclick={handleonClick}
          />}



            </div>
          </div>
          <div className="col-lg-6">
            <div className="mt-1">

            {data5.series !== undefined && <ReportCreate
            data={data5}
            type={graphtype}   
            stacked= {true}        
            labelposition="top"
             palette={"palette6"}
            onclick={handleonClick}
          />}



            </div>
          </div>

          <div className="col-lg-6">
            <div className="mt-1">

            {data4.series !== undefined && <ReportCreate
            data={data4}
            type={graphtype}           
            labelposition="top"
             palette={"palette1"}
            onclick={handleonClick}
          />}



            </div>
          </div>

          <div className="col-lg-6">
            <div className="mt-1">

            {data6.series !== undefined && <ReportCreate
            data={data6}
            type={graphtype}           
            labelposition="top"
             palette={"palette1"}
            onclick={handleonClick}
          />}



            </div>
          </div>

          <div className="col-sm-12 col-md-6 col-lg-6">
            <div className="mt-1">
              <div className="card">
                <div className="card-header text-center">
                  Age
                </div>
                <div className="card-body text-center">
                  {data3.series !== undefined &&  <Piechart
                        labels={data3.yLabels}
                        Datachart={data3.series[0].data}
                        chartOptions={chartopions}
                  />}
                </div>
              </div>
            </div>
          </div>

          <div className="col-sm-12 col-md-6 col-lg-6">
            <div className="mt-1">
              <div className="card">
                <div className="card-header text-center">
                  OS
                </div>
                <div className="card-body text-center">
                  { data2.series !== undefined &&  <Piechart
                    labels={data2.yLabels}
                    Datachart={data2.series[0].data}
                    chartOptions={chartopions}
                  />}
                </div>
              </div>
            </div>
          </div>

          {/* <div className="col-sm-6 col-md-3 col-lg-4">
            <div className="mt-1">
              <div className="card">
                <div className="card-header text-center">
                  IP2
                </div>
                <div className="card-body text-center">
                  {data2.series !== undefined &&  <Piechart
                       labels={data2.yLabels}
                       Datachart={data2.series[0].data}
                       chartOptions={chartopions}
                  />}
                </div>
              </div>
            </div>
          </div> */}

         

          {/* <div className="col-sm-6 col-md-3 col-lg-4">
            <div className="mt-1">
              <div className="card">
                <div className="card-header text-center">
                  BITEC
                </div>
                <div className="card-body text-center">
                  {data4.series !== undefined && <Piechart
                          labels={data4.yLabels}
                          Datachart={data4.series[0].data}
                          chartOptions={chartopions}
                  />}
                </div>
              </div>
            </div>
          </div> */}


        </div>







      </div>
    </div>
  );
};

export default Reportregister;
